import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { useDispatch, useStore } from "react-redux";
import {
  IonAlert,
  IonBadge,
  IonButton,
  IonCard,
  IonCheckbox,
  IonContent,
  IonDatetime,
  IonLabel,
  IonLoading,
  IonPage,
  IonSelect,
  IonSelectOption,
  IonProgressBar,
} from "@ionic/react";
import { decode } from "base64-arraybuffer";
import { useForm } from "react-hook-form";
import html2canvas from "html2canvas";

import {
  adjustBorderHeight,
  getQrCodeInfo,
  noInternetResponse,
  showToastMessage
} from "../../common/common";
import { getModelProfileData } from "../../data-services/edit-profile";
import { Network } from "@capacitor/network";
import axios from "axios";
import { get } from "../../storage/storage";



const QR14BeachLeashSuccess: React.FC = () => {
  const history = useHistory();
  const photoContainerRef = useRef<HTMLDivElement>(null);

  const [qrDetails, setQrDetails] = useState<any>();
  const [hasUserId, setHasUserId] = useState<boolean>(false);
  const populateQrCodeInfo = () => {
    let qrDetails = getQrCodeInfo();
    setQrDetails(qrDetails);
  }

  useEffect(() => {
    populateQrCodeInfo();
    adjustBorderHeight(670);
    // Fallback: check if user just signed up via Ionic Storage
    (async () => {
      const userId = await get("login_user_id");
      if (userId) setHasUserId(true);
    })();
  }, []);

  const trackCTAClick = async () => {
    const options: any = {
      method: "post",
      url: `${process.env.REACT_APP_HP_API_URL}/users/registerConsumerCTA`,
      data: {
        uuid: localStorage.getItem('uuid'),
        ctaType: "cta1",
        ctaLabel: 'Beach Leash CTA button pressed'
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    await axios(options);
    // TODO: Update this URL to the correct RaceTrack destination
    window.location.href = 'https://beachleash.com/collections/all'
  }

  return (
    <IonPage>

      <IonContent className="lay__container--14">
        <div className="lay__background">
          <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/Background2.png" />
        </div>

        {/* <div className="lay__background lay__background--border">
          <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/Border.png" />
        </div> */}

        {(typeof qrDetails != 'undefined' || hasUserId) && 
          <div className="lay__content--14">

            <div className="img__first" style={{marginTop: '100px', marginBottom: '0px'}}>
              <div className="talent-signup__section-title talent-signup__section-title--smaller2">
                <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/p3-img1.png" />
              </div>
            </div>
            <div className="promo-code">Use promo code <strong>LEASHPLZ</strong> at checkout to unlock free shipping.</div>

            {/* <div className="img__inline" style={{marginTop: '0px', zIndex: 3}}>
              <div className="">
                <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/p4-img2.png" />
              </div>
            </div>

            <div className="img__inline" style={{marginTop: '10px', zIndex: 3}}>
              <div className="">
                <img src="https://pulseqr.b-cdn.net/qr15TeamSnap/p4-img3.png" />
              </div>
            </div> */}

            <div className="img__inline" style={{marginTop: '20px', zIndex: 3, width: '280px'}}>
              <div onClick={trackCTAClick} style={{cursor: 'pointer'}}>
                <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/CTA-Submit2.png" />
              </div>
            </div>

            <div className="img__inline promo-expiration" style={{marginTop: '20px', zIndex: 3}}>
                <img src="https://pulseqr.b-cdn.net/qr14BeachLeash/p3-img2.png" />
            </div>

          </div>}
      </IonContent>

    </IonPage>
  );
};

export default QR14BeachLeashSuccess;
